import { HeaderNavItemUser } from 'softcat:components/header-nav-item-user.tsx';
import { LanguageSelector } from 'softcat:components/language-selector.tsx';
import { TerritorySelector } from 'softcat:components/territory-selector.tsx';

export const Header = () => {
    return (
        <div className="flex flex-1 justify-end gap-x-4 self-stretch lg:gap-x-6" data-testid="header">
            <div className="flex items-center gap-x-2">
                <TerritorySelector />
                <LanguageSelector />
                <HeaderNavItemUser />
            </div>
        </div>
    );
};
